module.exports = __webpack_public_path__ + "static/media/imagensProprias.55e6f640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Downloads/imagensProprias.jpg
// module id = 164
// module chunks = 0